import { NgModule } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { DialogModule } from 'primeng/dialog';
import { NzMessageModule } from 'ng-zorro-antd/message';







@NgModule({
    declarations: [],
    imports: [
        NzButtonModule,
        NzSelectModule,
        NzCollapseModule,
        NzCheckboxModule,
        NzCardModule,
        NzCarouselModule,
        NzDropDownModule,
        NzIconModule,
        NzTabsModule,
        NzRateModule,
        NzProgressModule,
        NzModalModule,
        NzPopconfirmModule,
        NzRadioModule,
        DialogModule,
        NzMessageModule
    ],
    exports: [
        NzFormModule,
        NzButtonModule,
        NzSelectModule,
        NzDatePickerModule,
        NzInputModule,
        NzCollapseModule,
        NzCheckboxModule,
        NzCardModule,
        NzCarouselModule,
        NzDropDownModule,
        NzIconModule,
        NzTabsModule,
        NzRateModule,
        NzProgressModule,
        NzModalModule,
        NzPopconfirmModule,
        NzRadioModule,
        DialogModule,
        NzMessageModule
    ]
})
export class ZorroModule { }
